import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "PackagesGrey__IconWrapper",
  componentId: "sc-1g95ykg-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    clipPath: "url(#PackagesGrey_tsx__clip0_713_8705)"
  }, React.createElement("path", {
    d: "M3.197 28.105h-1.9v1.135h1.9v-1.135zM15.72 28.105h-2.356v.87h2.355v-.87z",
    fill: "#6985A0"
  }), React.createElement("path", {
    d: "M8.509 27.687H1.14",
    stroke: "#6985A0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M2.979 20.694H1.648a.509.509 0 000 1.015H15.374a.509.509 0 000-1.015H14.03",
    stroke: "#6985A0",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M8.509 27.687h7.368",
    stroke: "#6985A0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M3.713 27.687v1.647H1.14v-5.06c0-.828.316-1.622.887-2.219l.338-.354 1.6-2.675a1.56 1.56 0 011.429-.935h6.178c.61 0 1.17.359 1.42.913l1.652 2.697.495.52c.405.427.738 1.255.738 1.844v5.269h-2.573v-1.647",
    stroke: "#6985A0",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M5.347 27.687l.559-1.114c.162-.324.546-.537.977-.537h3.238c.423 0 .807.209.969.525l.584 1.122M11.627 24.93c.103-.4.96-1.365 2.121-1.365.273 0 .55.086.644.35.094.265.145.606.06 1.067a.517.517 0 01-.427.414 6.334 6.334 0 01-2.073 0c-.218-.039-.371-.248-.32-.461l-.005-.004zM5.39 24.93c-.103-.4-.96-1.365-2.12-1.365-.274 0-.551.086-.645.35-.094.265-.145.606-.06 1.067.038.213.213.38.427.414.426.072 1.203.15 2.073 0 .218-.039.372-.248.32-.461l.005-.004zM10.24 24.257H6.777a.388.388 0 00-.388.388v.444c0 .214.174.388.388.388h3.465a.388.388 0 00.388-.388v-.444a.388.388 0 00-.388-.388z",
    fill: "#6985A0"
  }), React.createElement("path", {
    d: "M14.985 8.295l-10.423 2.13a1.788 1.788 0 01-1.899-.841L1.14 7.019l1.075-.537 1.596 1.365L14.422 5.68a2.96 2.96 0 011.677.145l.073.03a.983.983 0 01.345 1.6 2.962 2.962 0 01-1.532.84z",
    fill: "#6985A0",
    stroke: "#6985A0",
    strokeWidth: 0.4,
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.847 9.72l-2.022 4.463h1.8l5.342-5.53",
    fill: "#6985A0"
  }), React.createElement("path", {
    d: "M7.847 9.72l-2.022 4.463h1.8l5.342-5.53",
    stroke: "#6985A0",
    strokeWidth: 0.4,
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M8.21 6.947L5.64 3.66h2.18l3.623 2.624",
    fill: "#6985A0"
  }), React.createElement("path", {
    d: "M8.21 6.947L5.64 3.66h2.18l3.623 2.624",
    stroke: "#6985A0",
    strokeWidth: 0.4,
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M19.354 11.026H28.566M20.195 11.026v18.312M27.73 11.026v18.312",
    stroke: "#6985A0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M23.348 29.338v-3.157h1.446v3.157",
    fill: "#6985A0"
  }), React.createElement("path", {
    d: "M23.348 29.338v-3.157h1.446v3.157",
    stroke: "#6985A0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M31.86 29.338v-8.076h-4.13",
    stroke: "#6985A0",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M23.066 13.453h-.814a.324.324 0 00-.325.325v.806c0 .18.145.324.325.324h.814c.18 0 .325-.145.325-.324v-.806a.324.324 0 00-.325-.325zM25.89 13.453h-.814a.324.324 0 00-.324.325v.806c0 .18.145.324.324.324h.815c.179 0 .324-.145.324-.324v-.806a.324.324 0 00-.324-.325zM23.066 16.338h-.814a.324.324 0 00-.325.324v.806c0 .18.145.325.325.325h.814c.18 0 .325-.146.325-.325v-.806a.324.324 0 00-.325-.324zM25.89 16.338h-.814a.324.324 0 00-.324.324v.806c0 .18.145.325.324.325h.815c.179 0 .324-.146.324-.325v-.806a.324.324 0 00-.324-.324zM23.066 19.299h-.814a.324.324 0 00-.325.324v.806c0 .18.145.325.325.325h.814c.18 0 .325-.145.325-.325v-.806a.324.324 0 00-.325-.324zM25.89 19.299h-.814a.324.324 0 00-.324.324v.806c0 .18.145.325.324.325h.815c.179 0 .324-.145.324-.325v-.806a.324.324 0 00-.324-.324zM23.066 22.26h-.814a.324.324 0 00-.325.324v.806c0 .18.145.325.325.325h.814c.18 0 .325-.145.325-.325v-.806a.324.324 0 00-.325-.324zM25.89 22.26h-.814a.324.324 0 00-.324.324v.806c0 .18.145.325.324.325h.815c.179 0 .324-.145.324-.325v-.806a.324.324 0 00-.324-.324z",
    fill: "#6985A0"
  }), React.createElement("path", {
    d: "M31.86 29.338H20.195",
    stroke: "#6985A0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "PackagesGrey_tsx__clip0_713_8705"
  }, React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    transform: "translate(.5 3.021)",
    d: "M0 0h32v26.957H0z"
  }))));
}
const PackagesGrey = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(PackagesGrey);
export default Memo;